import React from 'react';
import PropTypes from 'prop-types';

import { LayoutComponent_Grid_Col as Col } from 'ggApp/modules/layout';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { StoreComponent_StoreShowPrice as ShowPrice } from 'ggApp/modules/store';
import { UnavailableBannerContext } from '../UnavailableBannerContex';

import CheckoutSingleProduct from '../SingleProduct';
import CheckoutItemQuantityHandler from '../ItemQuantityHandler';

import {
    ColumnValue,
    ColumnSubValue,
    ColTitle,
    StyledRowIn,
    StyledRow,
    Remover,
    StyledCol,
} from './styled';

export default class TableItem extends React.PureComponent {
    // eslint-disable-next-line react/static-property-placement
    static contextType = UnavailableBannerContext;

    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
        product: PropTypes.shape({}).isRequired,
        orderCurrencySymbol: PropTypes.string.isRequired,
        single: PropTypes.bool,
        duration: PropTypes.node,
        changeItemQuantity: PropTypes.func,
        removeItem: PropTypes.func,
        readOnly: PropTypes.bool,
    };

    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        single: true,
        duration: undefined,
        changeItemQuantity: () => {},
        removeItem: () => {},
        readOnly: false,
    };

    render() {
        const {
            product,
            orderCurrencySymbol,
            single,
            duration: planDuration,
            changeItemQuantity,
            removeItem,
            readOnly,
        } = this.props;
        const UnavailableBanner = this.context;
        const cols = readOnly ? [1, 1, 1] : [1, 1, 1, 0.2];
        return (
            <div>
                <StyledRow cols={[3.5, 3]} multipleProducts={!single} styledRow>
                    <StyledCol>
                        <CheckoutSingleProduct
                            product={product}
                            big={single}
                            absolute={single}
                            mobile={false}
                        >
                            {single && !readOnly && (
                                <UnavailableBanner
                                    variant={product.variant}
                                    lineItemId={product.id}
                                />
                            )}
                        </CheckoutSingleProduct>
                        {!single && !readOnly && (
                            <UnavailableBanner
                                variant={product.variant}
                                lineItemId={product.id}
                                withNoMarginTop
                            />
                        )}
                    </StyledCol>
                    <Col>
                        <StyledRowIn cols={cols} singleProduct={single} styledRowIn>
                            <Col flexDirectionColumn justifyCenter>
                                <ColTitle>
                                    <Translator tk="PRICE" />
                                </ColTitle>
                                <ColumnValue>
                                    <ShowPrice
                                        price={product && product.price}
                                        orderCurrencySymbol={orderCurrencySymbol}
                                    />
                                    /
                                    <Translator tk="MONTH_SHORT" />
                                </ColumnValue>
                            </Col>
                            <Col flexDirectionColumn justifyCenter>
                                <ColTitle>
                                    <Translator tk="QUANTITY" />
                                </ColTitle>
                                <ColumnValue>
                                    <CheckoutItemQuantityHandler
                                        readOnly={readOnly}
                                        product={product}
                                        changeItemQuantity={changeItemQuantity}
                                    />
                                </ColumnValue>
                            </Col>
                            <Col flexDirectionColumn justifyCenter>
                                <ColTitle>
                                    <Translator tk="TOTAL_PRICE" />
                                </ColTitle>
                                <ColumnValue>
                                    <ShowPrice
                                        price={product && product.total}
                                        orderCurrencySymbol={orderCurrencySymbol}
                                    />
                                    /
                                    <Translator tk="MONTH_SHORT" />
                                </ColumnValue>
                                {planDuration > 1 && (
                                    <ColumnSubValue>
                                        <Translator
                                            withValues={{
                                                duration: planDuration,
                                            }}
                                            tk="FOR_N_MONTHS"
                                        />
                                    </ColumnSubValue>
                                )}
                            </Col>
                            <Col flexDirectionColumn justifyCenter>
                                {!readOnly && <Remover onClick={removeItem}>×</Remover>}
                            </Col>
                        </StyledRowIn>
                    </Col>
                </StyledRow>
            </div>
        );
    }
}
